module.exports = __webpack_public_path__ + "static/img/07.9fa21fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20241216/07.png
// module id = nJFZ
// module chunks = 0